<template>
  <div class="guests-and-rooms-input">
    <div class="input-line">
      <div class="label">
        <span class="title">{{ tc('noums.roomSingular') }} {{ index }}</span>
        <span class="description">{{ tc('booking.maxGuests', { maxGuestsAllowed }) }}</span>
      </div>
      <div
        v-if="isAditional"
        class="input"
      >
        <button
          class="icon-close"
          :aria-label="tc('booking.close')"
          @click="$emit('remove')"
        />
      </div>
    </div>
    <hr>
    <div class="input-line">
      <div class="label">
        <span class="title">{{ tc('noums.adultPlural') }}</span>
        <span class="description">{{ selectedHotel.adultsAgeLabel ? selectedHotel.adultsAgeLabel : tc('booking.adultDescription') }}</span>
      </div>
      <div class="input">
        <button
          :class="['remove', { '--disabled': Number(adultGuestCount) <= 1 }]"
          :aria-disabled="Number(adultGuestCount) <= 1"
          tabindex="0"
          :aria-label="tc('booking.decreaseGuestCount') + ' ' + tc('noums.adultPlural')"
          @click="adultGuestCount--"
        >
          <span class="icon-minus" />
        </button>

        <div
          class="value"
          role="status"
        >
          <span class="sr-only">{{ tc('noums.adultPlural') }}</span> {{ adultGuestCount }}
        </div>

        <button
          :class="['add', { '--disabled': maxGuestsReached }]"
          :aria-disabled="maxGuestsReached"
          tabindex="0"
          :aria-label="tc('booking.increaseGuestCount') + ' ' + tc('noums.adultPlural')"
          @click="adultGuestCount++"
        >
          <span class="icon-add" />
        </button>
      </div>
      <input
        v-model="adultGuestCount"
        type="number"
        :max="maxGuestsAllowed"
        min="1"
      >
    </div>
    <hr class="with-padding">
    <div class="input-line">
      <div class="label">
        <span class="title">{{ tc('noums.childPlural') }}</span>
        <span class="description">{{ selectedHotel.childrenAgeLabel ? selectedHotel.childrenAgeLabel : tc('booking.childDescription') }}</span>
      </div>
      <div class="input">
        <button
          :class="['remove', { '--disabled': Number(childGuestCount) === 0 }]"
          :aria-disabled="Number(childGuestCount) === 0"
          tabindex="0"
          :aria-label="tc('booking.decreaseGuestCount') + ' ' + tc('noums.childPlural')"
          @click="childGuestCount--"
        >
          <span class="icon-minus" />
        </button>
        <div
          class="value"
          role="status"
        >
          <span class="sr-only">{{ tc('noums.childPlural') }}</span> {{ childGuestCount }}
        </div>
        <button
          :class="['add', { '--disabled': maxGuestsReached }]"
          :aria-disabled="maxGuestsReached"
          tabindex="0"
          :aria-label="tc('booking.increaseGuestCount') + ' ' + tc('noums.childPlural')"
          @click="childGuestCount++"
        >
          <span class="icon-add" />
        </button>
      </div>
      <input
        v-model="childGuestCount"
        type="number"
        :max="maxGuestsAllowed"
      >
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'GuestsInput',
    props: {
      value: {
        type: Object,
        validator: (value) => Object
          .keys(value)
          .filter(
            (k) => [
              'adultGuestCount',
              'childGuestCount'
            ].includes(k)
          ).length === 2
      },
      index: {
        type: [String, Number]
      },
      isAditional: Boolean,
      maxGuestsAllowed: {
        type: Number
      },
      selectedHotel: {
        type: Object
      }
    },
    data: () => ({
      adultGuestCount: 1,
      childGuestCount: 0
    }),
    computed: {
      ...mapGetters('i18n', ['tc']),
      totalGuests() {
        return Number(this.adultGuestCount) + Number(this.childGuestCount)
      },
      maxGuestsReached() {
        return this.totalGuests >= this.maxGuestsAllowed
      },
      isDisabled() {
        return this.adultGuestCount == null || this.adultGuestCount <= 0
      }
    },
    watch: {
      totalGuests(val) {
        this.$emit('input', {
          ...this.value,
          adultGuestCount: Number(this.adultGuestCount),
          childGuestCount: Number(this.childGuestCount)
        })
      },
      adultGuestCount(val) {
        this.$emit('isDisabled', this.isDisabled)
      }
    },
    mounted() {
      this.$emit('isDisabled', this.isDisabled)
    },
    created() {
      this.adultGuestCount = this.value.adultGuestCount
      this.childGuestCount = this.value.childGuestCount
      if (!this.adultGuestCount) this.adultGuestCount = 0
    }
  }
</script>
